import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
function Innovation() {
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>
                Tadqiqotlar va Innovatsiyalar
              </h4>
            </div>
            <p>
              Toshkent farmatsevtika instituti Markaziy Osiyodagi yagona
              farmatsevtika oliy taʼlim muassasasidir. Rasmiy ravishda 1937-yil
              16-iyulda Oʻzbekiston Sogʻliqni saqlash xalq komissarining
              buyrugʻi bilan Toshkent tibbiyot institutining alohida kafedralari
              negizida tashkil etilgan. Bu tadbir nafaqat Oʻzbekistonda, balki
              butun Markaziy Osiyo davlatlarida farmatsevtika mutaxassislarini
              tayyorlashga zamin yaratdi.
            </p>

            <p>
              Institut tashkil topganiga 85 yil toʻldi va qisqa muddatli
              shakllanish va rivojlanish tarixidan soʻng bugungi kunda salmoqli
              salohiyatga, yuksak ijodiy salohiyatga ega yirik taʼlim, ilmiy,
              maʼnaviy-maʼrifiy markazga aylandi. Mustaqillik yillaridan
              farmatsevtika taʼlimini isloh qilishda katta muvaffaqiyatlarga
              erishdi.
            </p>

            <p>
              Hozirgi kunda institut fakultet va kafedralarida 300 dan ortiq
              professor-oʻqituvchilar, 55 nafar fan doktorlari va 120 dan ortiq
              fan nomzodlari faoliyat koʻrsatmoqda. Ular mamlakatimizda yuqori
              malakali farmakognoz, farmatsevt-kimyogar, farmatsevt-biotexnolog,
              farmatsevtika texnologlari, farmatsevt-farmakolog, farmatsevtika
              iqtisodiyoti va ishlab chiqarishini tashkil etish va boshqarish
              mutaxassislarini tayyorlaydi. Ayni paytda farmatsevtika ilm-fanini
              rivojlantirish, aholini arzon va samarali dori vositalari bilan
              taʼminlashni yaxshilash, mahalliy xomashyo asosida yangi dori
              vositalari yaratishga muyassar boʻlmoqda.
            </p>

            <p>
              Maʼlumki, ijtimoiy, iqtisodiy, ilmiy-texnikaviy muammolarni yuqori
              saviyada hal etishga qodir yuqori malakali, raqobatbardosh kadrlar
              tayyorlash respublikamizdagi barcha oliy taʼlim muassasalari
              oldidagi ustuvor vazifa hisoblanadi.
            </p>

            <p>
              Ilmiy izlanishlar natijalari, ayniqsa maxalliy xom ashyolar
              asosida yaratilgan yangi preparatlar tibbiyot amaliyotiga faol
              joriy etilmoqda. Institut olimlari tomonidan sintetik va tabiiy
              birikmalar asosida, shu jumladan maxalliy oʻsimlik xom ashyolari
              asosida yuqori samaradorlikka ega dori vositalarini yaratish
              borasida salmoql izlanishlarni amalga oshirib kelmoqda.
            </p>
            <p>
              Shu jumladan mikro-va makroelementlar va biologik faol
              ligandalarning koordinatsion birikmalari asosida yaratilgan
              Piratsin, Feraks, Kupir, Kobalt-30, Koamid, shuningdek oʻsimliklar
              asosida oligan Gelrem, Flegmen, Altrombosepin, Mekritin, “Stiflos”
              peshob xaydovchi yigʻmasi bugungi kunda farmatsevtik sanoati
              korxonalari tomonidan ishlab chiqarishga joriy etilgan va
              etilayotgan yuqori samaradorlikka ega bulgan mahalliy dori
              vositalaridir. Institut 2008-yildan doimiy ravishda Respublika
              “Innovatsion goyalar, texnologiyalar va loyixalar” yarmarkasida
              faol katnashib, faxrli natijalarni qoʻlga kiritib kelgan va
              keyingi yillarda Oʻzbekiston Respublikasi Innovatsion rivojlanish
              vazirligi tomonidan ananaviy oʻtkazib kelinayotgan “InnoWeek”
              innovatsion gʻoyalar haftaligida munosib qatnashib kelayotganligi
              institut jamoasi tomonidan amalga oshirilayotgan ilmiy
              faoliyatdagi yutuqlar ifodasidir. Xalqaro koʻrinishga ega va
              zamonaviy farmatsevtika fan va yutuqlarining afzalliklari bilan
              jihozlangan institut fanlararo tadqiqotlarni rivojlantirib,
              innovatsion saloxiyatini yildan-yilga oshirib kelmoqda. Institut
              tabiiy faol moddalar va dori preperatlari samaradorligi uchun
              Koordinatsion birikmalar va biologik faol moddalarni
              farmako-toksikologik taxlil milliy tadqiqot laboratoriyasiga, 14
              ta oʻquv laboratoriyalari canoat korxonalariga yetuk mutaxassis
              kadrlarni tayyorlash, dorivor oʻsimliklar yetishtirish va qayta
              ishlashni yanada rivojlantirish uchun qulay muhit yaratish,
              sohaning eksport salohiyatini oshirish, shuningdek, taʼlim,
              ilm-fan va ishlab chiqarish jarayonlarini integratsiyalash
              maqsadida yaratilgan "oʻquv tajriba ishlab chiqarish kompleksi" va
              ustav fondi asosida faoiyat yuritayotgan “Dori vositalarini
              standartlash Ilmiy Markazi” MCHJ iolmiy laboratoriyalarida
              innovatsion dori-darmonlarni klinikagacha tadqiq qilish va ishlab
              chiqish uchun innovatsion platformalarni yaratdi. Mazkur
              laboratoriyalar yangi dori-darmonlarni tadqiq etish va ishlab
              chiqishni umumiy rivojlanishiga yordam beradi.
            </p>
            <p>
              Bugungi kunda institut 13 ta tadqiqot loyihalari (xorijiy OTMlar
              bilan hamkorlikda xalqaro grant, davlat ilmiy-texnik dasturlari
              doirasidagi loyihalar, Startap loyihalar) ni amalga oshirdi va
              koʻplab tadqiqot fondlarini qoʻlga kiritdi va mamlakatning eng
              yaxshi tibbiyot oliygoxlari qatoriga kirdi. Institutda 338 nafar
              professor-oʻqituvchilar faoliyat olib boradi. Ilmiy salohiyat
              50,1% tashkil etadi. Professor-oʻqituvchilarining oʻrtacha yoshi
              43 yoshni tashkil etadi. Ilmiy pedagogik kadrlar tayyorlash 4 ta
              ixtisoslik boʻyicha amalga oshiriladi. Soʻngi ikki yilda
              institutda 9 nafar fan doktori (DSc) va 26 nafar falsafa doktori
              (PhD) tayyorlangan. Hozirgi kunda 2 nafar doktorant (DSc), 11
              nafar tayanch doktorant (PhD) va 54 nafar mustaqil izlanuvchilar
              oʻz ilmiy mavzulari boʻyicha izlanish olib bormoqdalar. Bu
              holatlar yiliga ilmiy salohiyatni 3,5 % ga koʻtarish imkonini
              beradi. Institut professor-oʻqituvchilari tomonidan soʻngi 2 yilda
              17 ta darslik, 50 ta monografiya va 241 ta oʻquv va uslubiy
              qoʻllanma chop etilgan. Soʻngi ikki yilda institut olib borilgan
              ilmiy ishlar natijasida xodimlari tomonidan chop etilgan
              maqolalar: 928 ta xorijiy jurnallarda, shu jumladan yuqori
              reytinglarga kiruvchi jurnallarda 446 ta va respublika
              jurnallarida 502 ta maqolalar nashr etilgan. Soʻngi ikki yilda
              institut professor-oʻqituvchilarining ilmiy ishlanmalariga 21 ta
              patent, 81 ta foydali modellar uchun guvohnomalar olingan.
            </p>
            <p>
              Institut kutubxonasi va oʻqituvchilari bugungi kunda Scopus,
              ScienceDirect, Ebesco, Springer, eLibrary, Elsevier, Waley
              bazalariga ulangan. Web of Science ga ulanish boʻyicha kelishuv
              olib borilyapti. Hamkorlik dasturlari doirasida Sankt-Peterburg
              Davlat kimyo-farmatsevtika instituti bilan qoʻshma dastur va
              fakultet ochildi. Oʻzbek-Rossiya taʼlim fakultetida 2ta kurs
              kesimida jami 127 nafar talabalar taʼlim olmoqda. Sankt-Peterburg
              universiteti elektron kutubxonasi institut axborot-resurs
              markaziga integratsiya qilindi va talabalar elektron kutubxonadan
              foydalanishi yoʻlga qoʻyildi. Institut xalqaro miqyosdagi
              reytinglarga kirish uchun yaratilgan imkoniyatlardan keng
              foydalanmoqda, jumladan, 2021-2022-yilllar davomida Institut
              xalqaro universitetlarning Times Higher Education reytingida
              impakt-faktor boʻyicha eng yaxshi 1000 talikka kirdi (800-1000).
              Uning oʻrni Gender tengligi reytingida 301, Salomatlik va
              sogʻlomlashtirish reytinglari boʻyicha 401 oʻrinlarga munosib
              koʻrildi. Shuningdek, 2021-yil 2-sentyabrdan Institut 2022-yilgi
              Oliy taʼlim jahon universitetlari reytingiga "reportyor" maqomi
              berilib, muhim global reyting uchun maʼlumotlarni taqdim etgan
              universitetlar qatorida tan olingan. Institut Skopus va Web of
              Science halqaro maʼlumotlar bazasidagi ilmiy jurnallarda maqola
              chop etish boʻyicha keyingi 2 yildagi oʻsish darajasi 13,5
              barobarga oʻsdi. Bundan tashqari, Malayziyaning Linkoln
              universiteti, Turkiyaning Egey universiteti, Vengriyaning
              Debretsen universitetlari bilan qoʻshma dastur va fakultetlar
              ochish boʻyicha memorandumlar imzolandi. Institutga Jaxon banki
              mablagʻlari hisobiga 4 ta oʻquv-ilmiy laboratoriyalar
              (Sud-toksikologiya, organik va biologik kimyo; Farmakologiya,
              fiziologiya, patologiya; Mikrobiologiya; Fiziologiya, patologik
              fiziologiya va odam anatomiyasi) uchun jami 5 mlrd 137 mln soʻmlik
              zamonaviy asbob uskunalar olib kelindi.
            </p>
            <p>
              Soʻngi 2 yil mobaynida 30 tadan ortiq korxonalar bilan xoʻjalik
              shartnomalari imzolangan. Shartnomalarning umumiy summasi –
              1 024 951 451 sum (1 milliard 24 million 951 ming 451 soʻm)
              tashkil qiladi. Ushbu xoʻjalik shartnomalari asosida institut
              professor oʻqituvchilarning ilmiy salohiyatidan foydalanilgan
              xolda maxalliy ishlab chiqaruvchilarga dori vositalarini ishlab
              chiqarish davomida kelib chiqiladigan muammolarni (korxona
              kadrlarini malakasini oshirish, dori vositalarini ishlab chiqarish
              texnologiyasi va sifat tahlili borasida) hal qilishga qaratilgan
              kamida 10 turdagi xizmatlar koʻrsatilgan. Institutda yiliga 10
              tonna dorivor oʻsimliklarni qayta ishlab, 3,0-3,5 tonna quruq
              ekstrakt oladigan va ular asosida 10 mln tabletka, 1,5-2,0 mln
              kapsula, 2,0-2,5 ming quti qadoq dori formalari ishlab-chiqarish
              imkonini beradigan “ToshFarmi oʻquv-tajriba ishlab-chiqarish
              kompleksi”, ilmiy laboratoriya va dorixona simulyatsion-modullari
              qurib bitkazildi.
            </p>
          </div>

          <div className="card5__custom">
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
            <img src="img/5.png" alt />
          </div>
        </div>
      </div>
      <div className="mt" />
      <Footer />
    </div>
  );
}

export default Innovation;
